module.exports = __webpack_public_path__ + "static/wechat-02c45aa0a0126ac9b08c45cfb1ede19b.png";